import { useEffect } from "react";

import { SpecialistsListHero, SpecialistsListIframe } from "@/components";
import { useGetSpecialistsQuery } from "@/store";
import { useTranslation } from "react-i18next";

function SpecialistsIframePage() {
  const { i18n } = useTranslation();
  const { isLoading } = useGetSpecialistsQuery({
    lang: i18n.language,
  });

  useEffect(() => {
    function sendHeight() {
      setTimeout(() => {
        const height = document.body.scrollHeight;
        window.parent.postMessage({ iframeHeight: height }, "https://mhhelpline.com/uk/specialists/");
      }, 800);
    }

    sendHeight();
    window.addEventListener("resize", sendHeight);

    return () => {
      window.removeEventListener("resize", sendHeight);
    };
  }, []);
  return (
    <div
      className="flex w-full flex-col items-center justify-center gap-4 pt-7 lg:gap-7"
      style={{ margin: 0, padding: 0, overflow: "hidden", minHeight: "100vh" }}
    >
      <SpecialistsListHero className="hidden" />
      <SpecialistsListIframe isLoading={isLoading} />
    </div>
  );
}

export { SpecialistsIframePage };
